<template>
  <div>
    <a-drawer
      :title="(action == 'add' ? '添加' : '修改') + '巡查任务'"
      :width="520"
      :visible="visible"
      destroyOnClose
      @close="
        $emit('update:visible', false);
        form.resetFields();
      "
    >
      <a-form
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
        @submit="handleOk"
      >
        <a-form-item label="id" v-show="false">
          <a-input v-decorator="['id']"> </a-input>
        </a-form-item>
        <a-form-item label="巡查任务名称">
          <a-input
            placeholder="请输入巡查任务名称"
            v-decorator="[
              'name',
              { rules: [{ required: true, message: '请输入巡查任务名称' }] }
            ]"
          >
          </a-input>
        </a-form-item>
        <a-form-item label="巡查设备">
          <a-select
            v-decorator="[
              'board_id',
              {
                initialValue: '',
                rules: [{ required: true, message: '请选择巡查设备' }]
              }
            ]"
            placeholder="请选择巡查设备"
          >
            <a-select-option
              v-for="item in patrolDeviceList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="巡查开始时间">
          <a-date-picker
            style="width: 100%"
            v-decorator="[
              'start_time',
              {
                initialValue: initialStartTime,
                rules: [{ required: true, message: '请选择巡查开始时间' }]
              }
            ]"
            format="YYYY-MM-DD HH:mm:ss"
            :allowClear="false"
            show-time
          />
        </a-form-item>
        <a-form-item label="巡查结束时间">
          <a-date-picker
            style="width: 100%"
            v-decorator="['end_time']"
            format="YYYY-MM-DD HH:mm:ss"
            show-time
          />
        </a-form-item>
        <a-form-item label="任务状态">
          <a-select
            v-decorator="[
              'task_status',
              {
                initialValue: 1,
                rules: [{ required: true, message: '请选择任务状态' }]
              }
            ]"
            placeholder="请选择任务状态"
            @change="taskStatusChange"
          >
            <a-select-option
              v-for="item in taskStatusOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="巡查人员">
          <a-select
            v-decorator="[
              'ops_user_id',
              {
                initialValue: '',
                rules: [{ required: true, message: '请选择巡查人员' }]
              }
            ]"
            placeholder="请选择巡查人员"
            option-filter-prop="children"
            showSearch
          >
            <a-select-option
              v-for="item in operationUserList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="巡查线路">
          <a-select
            v-decorator="[
              'road_id',
              {
                initialValue: '',
                rules: [{ required: true, message: '请选择巡查线路' }]
              }
            ]"
            placeholder="请选择巡查线路"
            option-filter-prop="children"
            showSearch
          >
            <a-select-option
              v-for="item in roadList"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="巡航公里数">
          <a-input
            v-decorator="[
              'task_distance',
              { rules: [{ pattern: /^\d+(\.\d+)?$/, message: '请输入数字' }] }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="巡航河道公里数">
          <a-input
            v-decorator="[
              'task_distance_total',
              { rules: [{ pattern: /^\d+(\.\d+)?$/, message: '请输入数字' }] }
            ]"
          ></a-input>
        </a-form-item>
        <a-form-item label="声呐图片">
          <a-row>
            <a-col :span="8" v-for="info in sonarFileList" :key="info.uid">
              <img-lng-lat-show
                :info="info"
                :trackDataInfo="trackDataInfo"
                type="sonar"
                @removeFile="removeFile"
                @getLngLatInfo="getLngLatInfo"
              ></img-lng-lat-show>
            </a-col>
            <a-col :span="8" v-if="sonarFileList.length < 6">
              <a-upload
                v-decorator="[
                  'pic_sonar',
                  {
                    initialValue: sonarFileList,
                    valuePropName: 'pic_sonar',
                    getValueFromEvent: normFile
                  }
                ]"
                multiple
                accept="image/*"
                :beforeUpload="beforeUploadFile"
                :customRequest="e => httpRequestFile(e, 'sonar')"
                :showUploadList="false"
                list-type="picture-card"
              >
                <div v-if="sonarFileList.length < 6">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">
                    上传图片
                  </div>
                </div>
              </a-upload>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="ADCP图片">
          <a-row>
            <a-col :span="8" v-for="info in adcpFileList" :key="info.uid">
              <img-lng-lat-show
                :info="info"
                :trackDataInfo="trackDataInfo"
                type="adcp"
                @removeFile="removeFile"
                @getLngLatInfo="getLngLatInfo"
              ></img-lng-lat-show>
            </a-col>
            <a-col :span="8" v-if="adcpFileList.length < 6">
              <a-upload
                v-decorator="[
                  'pic_adcp',
                  {
                    initialValue: adcpFileList,
                    valuePropName: 'pic_adcp',
                    getValueFromEvent: normFile
                  }
                ]"
                multiple
                accept="image/*"
                :beforeUpload="beforeUploadFile"
                :customRequest="e => httpRequestFile(e, 'adcp')"
                :showUploadList="false"
                list-type="picture-card"
              >
                <div v-if="adcpFileList.length < 6">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">
                    上传图片
                  </div>
                </div>
              </a-upload>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="无人机图片">
          <a-row>
            <a-col :span="8" v-for="info in mainFileList" :key="info.uid">
              <img-lng-lat-show
                :info="info"
                :trackDataInfo="trackDataInfo"
                type="main"
                @removeFile="removeFile"
                @getLngLatInfo="getLngLatInfo"
              ></img-lng-lat-show>
            </a-col>
            <a-col :span="8" v-if="mainFileList.length < 6">
              <a-upload
                v-decorator="[
                  'pic_main',
                  {
                    initialValue: mainFileList,
                    valuePropName: 'pic_main',
                    getValueFromEvent: normFile
                  }
                ]"
                multiple
                accept="image/*"
                :beforeUpload="beforeUploadFile"
                :customRequest="e => httpRequestFile(e, 'main')"
                :showUploadList="false"
                list-type="picture-card"
              >
                <div v-if="mainFileList.length < 6">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">
                    上传图片
                  </div>
                </div>
              </a-upload>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="手机图片">
          <a-row>
            <a-col :span="8" v-for="info in otherFileList" :key="info.uid">
              <img-lng-lat-show
                :info="info"
                :trackDataInfo="trackDataInfo"
                type="other"
                @removeFile="removeFile"
                @getLngLatInfo="getLngLatInfo"
              ></img-lng-lat-show>
            </a-col>
            <a-col :span="8" v-if="otherFileList.length < 6">
              <a-upload
                v-decorator="[
                  'pic_other',
                  {
                    initialValue: otherFileList,
                    valuePropName: 'pic_other',
                    getValueFromEvent: normFile
                  }
                ]"
                multiple
                accept="image/*"
                :beforeUpload="beforeUploadFile"
                :customRequest="e => httpRequestFile(e, 'other')"
                :showUploadList="false"
                list-type="picture-card"
              >
                <div v-if="otherFileList.length < 6">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">
                    上传图片
                  </div>
                </div>
              </a-upload>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="声呐文件">
          <a-upload
            v-decorator="[
              'sonar_file',
              {
                initialValue: sonarPdfFileList,
                valuePropName: 'sonar_file'
              }
            ]"
            accept=".pdf"
            :beforeUpload="beforeUploadPdfFile"
            :customRequest="httpRequestPdfFile"
            :remove="removePdfFile"
            :file-list="sonarPdfFileList"
          >
            <div v-if="sonarPdfFileList.length < 1">
              <a-icon type="plus" />
              <span class="ant-upload-text">
                上传文件
              </span>
            </div>
          </a-upload>
        </a-form-item>
        <a-form-item label="备注">
          <a-textarea v-decorator="['remark']" />
        </a-form-item>
      </a-form>

      <div class="drawer-btn">
        <a-button type="danger" @click="handleArchive" style="float: left;">
          任务归档
        </a-button>
        <a-button
          :style="{ marginRight: '8px' }"
          @click="
            $emit('update:visible', false);
            form.resetFields();
          "
        >
          取消
        </a-button>
        <a-button type="primary" @click="handleOk">
          确定
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import {
  addPatrolTask,
  updatePatrolTask,
  getPatrolRouteList,
  ossUpload,
  ossUploadPdf,
  archivePushTask
} from "@/api/api";
import {
  getUuid,
  extractLngLatFromImg,
  flattenArrayDeep,
  isCheckNumber
} from "@/utils/utils";
import { OSS_PIC_BASE_URL, OSS_FILE_BASE_URL } from "@/config/config";
import { taskStatusOptions } from "@/options/common";
import moment from "moment";
import _ from "lodash";
import ImgLngLatShow from "@/pages/patrol_record/components/ImgLngLatShow";

const editFields = [
  "id",
  "name",
  "board_id",
  "start_time",
  "end_time",
  "ops_user_id",
  "road_id",
  "task_status",
  "task_distance",
  "task_distance_total",
  "remark"
];

export default {
  data() {
    return {
      roadList: [],
      form: this.$form.createForm(this),
      initialStartTime: moment(),
      originForm: null,
      sonarFileList: [],
      adcpFileList: [],
      mainFileList: [],
      otherFileList: [],
      sonarPdfFileList: [],
      ossBaseUrl: OSS_PIC_BASE_URL,
      ossImgProcess: "?x-oss-process=image/resize,m_fill,w_100,h_100",
      patrolDeviceList: [],
      taskStatusOptions
    };
  },
  props: {
    action: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    },
    record: {
      type: Object,
      default: () => {}
    },
    trackDataInfo: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ImgLngLatShow
  },
  computed: {
    ...mapState([
      "authUserInfo",
      "sensortypes",
      "groupTree",
      "alarmTypeList",
      "groupTree",
      "operationUserList"
    ]),
    ...mapGetters(["defaultInfo"])
  },
  mounted() {
    const flattenTreeArr = flattenArrayDeep(this.groupTree);
    this.patrolDeviceList = flattenTreeArr.filter(
      x => x.dev_type == 2 || x.dev_type == 3
    );
    this.getRoadList();
  },
  watch: {
    visible() {
      if (this.action == "edit") {
        this.updateCurPollutant();
      } else {
        this.initialStartTime = moment();
        this.sonarFileList = [];
        this.adcpFileList = [];
        this.mainFileList = [];
        this.otherFileList = [];
        this.sonarPdfFileList = [];
      }
    },
    record() {
      this.getFileFromRecord();
    }
  },
  methods: {
    moment,
    validateSameDay(rules, value, callback) {
      if (value) {
        const [start, end] = value;
        if (!moment(start).isSame(end, "day")) {
          callback("所选日期必须为同一天");
        } else {
          callback();
        }
      } else {
        callback("请选择巡查日期");
      }
    },
    getFileFromRecord() {
      if (this.record?.pic_sonar) {
        // 声呐图片
        this.sonarFileList = this.record.pic_sonar.map(item => {
          return {
            uid: getUuid(),
            name: item.pic_url,
            status: "done",
            lat: item.lat,
            lng: item.lng,
            url: this.ossBaseUrl + item.pic_url + this.ossImgProcess
          };
        });
      }
      if (this.record?.pic_adcp) {
        // ADCP图片
        this.adcpFileList = this.record.pic_adcp.map(item => {
          return {
            uid: getUuid(),
            name: item.pic_url,
            status: "done",
            lat: item.lat,
            lng: item.lng,
            url: this.ossBaseUrl + item.pic_url + this.ossImgProcess
          };
        });
      }
      if (this.record?.pic_main) {
        // 正摄图图片
        this.mainFileList = this.record.pic_main.map(item => {
          return {
            uid: getUuid(),
            name: item.pic_url,
            status: "done",
            lat: item.lat,
            lng: item.lng,
            url: this.ossBaseUrl + item.pic_url + this.ossImgProcess
          };
        });
      }
      if (this.record?.pic_other) {
        // 其它图片
        this.otherFileList = this.record.pic_other.map(item => {
          return {
            uid: getUuid(),
            name: item.pic_url,
            status: "done",
            lat: item.lat,
            lng: item.lng,
            url: this.ossBaseUrl + item.pic_url + this.ossImgProcess
          };
        });
      }
      if (this.record?.sonar_file) {
        // 文件
        this.sonarPdfFileList = this.record.sonar_file.map(fileName => {
          return {
            uid: getUuid(),
            name: fileName,
            status: "done",
            url: OSS_FILE_BASE_URL + fileName
          };
        });
      }
    },
    getLngLatInfo(value, info, type) {
      if (type == "sonar") {
        this.sonarFileList.forEach(x => {
          if (info.name == x.name) {
            x.lng = Number(value.split(",")[0]);
            x.lat = Number(value.split(",")[1]);
          }
        });
      } else if (type == "adcp") {
        this.adcpFileList.forEach(x => {
          if (info.name == x.name) {
            x.lng = Number(value.split(",")[0]);
            x.lat = Number(value.split(",")[1]);
          }
        });
      } else if (type == "main") {
        this.mainFileList.forEach(x => {
          if (info.name == x.name) {
            x.lng = Number(value.split(",")[0]);
            x.lat = Number(value.split(",")[1]);
          }
        });
      } else if (type == "other") {
        this.otherFileList.forEach(x => {
          if (info.name == x.name) {
            x.lng = Number(value.split(",")[0]);
            x.lat = Number(value.split(",")[1]);
          }
        });
      } else {
      }
    },
    async httpRequestFile(info, type) {
      let file = info.file;
      let lngLatInfo = {};
      try {
        lngLatInfo = await extractLngLatFromImg(file);
        if (lngLatInfo.lng && lngLatInfo.lat) {
          let gcj = coordtransform.wgs84togcj02(lngLatInfo.lng, lngLatInfo.lat);
          lngLatInfo.lng = gcj[0];
          lngLatInfo.lat = gcj[1];
        }
      } catch (error) {
        console.log(error);
      }
      try {
        let fileName = await ossUpload(getUuid(), file);
        if (type == "sonar") {
          // 声呐图片
          this.sonarFileList.push({
            uid: file.uid,
            name: fileName,
            status: "done",
            lng: lngLatInfo.lng || "",
            lat: lngLatInfo.lat || "",
            url: this.ossBaseUrl + fileName + this.ossImgProcess
          });
        } else if (type == "adcp") {
          // ADCP图片
          this.adcpFileList.push({
            uid: file.uid,
            name: fileName,
            status: "done",
            lng: lngLatInfo.lng || "",
            lat: lngLatInfo.lat || "",
            url: this.ossBaseUrl + fileName + this.ossImgProcess
          });
        } else if (type == "main") {
          // 正摄图
          this.mainFileList.push({
            uid: file.uid,
            name: fileName,
            status: "done",
            lng: lngLatInfo.lng || "",
            lat: lngLatInfo.lat || "",
            url: this.ossBaseUrl + fileName + this.ossImgProcess
          });
        } else if (type == "other") {
          // 其它图片
          this.otherFileList.push({
            uid: file.uid,
            name: fileName,
            status: "done",
            lng: lngLatInfo.lng || "",
            lat: lngLatInfo.lat || "",
            url: this.ossBaseUrl + fileName + this.ossImgProcess
          });
        } else {
        }
      } catch (error) {
        console.log(error);
      }
    },
    beforeUploadFile(file, fileList) {
      const isImage = file.type.startsWith("image/");
      // const isImage = ['image/png', 'image/jpeg', 'image/jpg'].includes(file.type);
      if (!isImage) {
        this.$message.error("请上传图片文件！");
      }
      return isImage; // 返回 true 允许上传 false 禁止上传
    },
    removeFile(file, type) {
      return new Promise((resolve, reject) => {
        this.$confirm({
          title: "确认删除此图片?",
          okText: "确认",
          cancelText: "取消",
          onOk: () => {
            if (type == "sonar") {
              // 声呐图片
              this.sonarFileList = this.sonarFileList.filter(
                x => x.name !== file.name
              );
            } else if (type == "adcp") {
              // ADCP图片
              this.adcpFileList = this.adcpFileList.filter(
                x => x.name !== file.name
              );
            } else if (type == "main") {
              // 正摄图
              this.mainFileList = this.mainFileList.filter(
                x => x.name !== file.name
              );
            } else if (type == "other") {
              // 其它图片
              this.otherFileList = this.otherFileList.filter(
                x => x.name !== file.name
              );
            } else {
            }
            resolve();
          },
          onCancel: () => {
            this.$message.warning("取消删除");
            reject();
          }
        });
      });
    },
    normFile(e) {
      if (Array.isArray(e)) {
        return e;
      }
      const removedCount = e.fileList.filter(file => file.status === "removed")
        .length;
      if (e.fileList.length === removedCount) {
        return [];
      }
      return e && e.fileList;
    },
    async httpRequestPdfFile(info) {
      let file = info.file;
      try {
        let index = file.name.lastIndexOf(".");
        let fileName = await ossUploadPdf(
          file.name.substring(0, index) +
            getUuid() +
            file.name.substring(index),
          file
        );
        this.sonarPdfFileList.push({
          uid: file.uid,
          name: fileName,
          status: "done",
          url: OSS_FILE_BASE_URL + fileName
        });
      } catch (error) {
        console.log(error);
      }
    },
    beforeUploadPdfFile(file, fileList) {
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        this.$message.error("请上传 PDF 文件！");
      }
      return isPDF;
    },
    removePdfFile(file) {
      return new Promise((resolve, reject) => {
        this.$confirm({
          title: "确认删除此图片?",
          okText: "确认",
          cancelText: "取消",
          onOk: () => {
            this.sonarPdfFileList = this.sonarPdfFileList.filter(
              x => x.name !== file.name
            );
            resolve();
          },
          onCancel: () => {
            this.$message.warning("取消删除");
            reject();
          }
        });
      });
    },
    async getRoadList() {
      try {
        let res = await getPatrolRouteList({
          group_id: this.defaultInfo.defaultGroupId
        });
        let data = res.data.items;
        this.roadList = data;
      } catch (error) {
        console.log(error);
      }
    },
    handleOk() {
      if (this.sonarFileList.length) {
        let isLngLatExist = this.sonarFileList.some(
          item => !item.lng || !item.lat
        );
        if (isLngLatExist) {
          this.$message.warning("声呐图片存在没有经纬度的情况，请检查");
          return;
        }
      }
      if (this.adcpFileList.length) {
        let isLngLatExist = this.adcpFileList.some(
          item => !item.lng || !item.lat
        );
        if (isLngLatExist) {
          this.$message.warning("ADCP图片存在没有经纬度的情况，请检查");
          return;
        }
      }
      if (this.mainFileList.length) {
        let isLngLatExist = this.mainFileList.some(
          item => !item.lng || !item.lat
        );
        if (isLngLatExist) {
          this.$message.warning("无人机图片存在没有经纬度的情况，请检查");
          return;
        }
      }
      if (this.otherFileList.length) {
        let isLngLatExist = this.otherFileList.some(
          item => !item.lng || !item.lat
        );
        if (isLngLatExist) {
          this.$message.warning("手机图片存在没有经纬度的情况，请检查");
          return;
        }
      }
      this.form.validateFields(async (err, values) => {
        if (err) return;
        if (_.isEqual(this.originForm, values)) {
          this.$emit("update:visible", false);
          return;
        }
        let p = "";
        const info = this.patrolDeviceList.find(x => x.id == values.board_id);
        const params = {
          group_id: this.defaultInfo.defaultGroupId,
          name: values.name,
          board_id: values.board_id,
          device: info.name,
          start_time: moment(values.start_time).format("YYYY-MM-DD HH:mm:ss"),
          end_time: values.end_time
            ? moment(values.end_time).format("YYYY-MM-DD HH:mm:ss")
            : null,
          ops_user_id: values.ops_user_id,
          road_id: values.road_id,
          remark: values.remark,
          pic_sonar: this.sonarFileList.map(x => {
            return { pic_url: x.name, lat: x.lat, lng: x.lng };
          }),
          pic_adcp: this.adcpFileList.map(x => {
            return { pic_url: x.name, lat: x.lat, lng: x.lng };
          }),
          pic_main: this.mainFileList.map(x => {
            return { pic_url: x.name, lat: x.lat, lng: x.lng };
          }),
          pic_other: this.otherFileList.map(x => {
            return { pic_url: x.name, lat: x.lat, lng: x.lng };
          }),
          sonar_file: this.sonarPdfFileList.map(x => x.name),
          task_status: values.task_status,
          task_distance: isCheckNumber(values.task_distance)
            ? values.task_distance * 1000
            : null,
          task_distance_total: isCheckNumber(values.task_distance_total)
            ? values.task_distance_total * 1000
            : null
        };
        if (this.action == "add") {
          p = addPatrolTask;
        } else {
          params.id = values.id;
          p = updatePatrolTask;
        }

        try {
          let res = await p(params);
          this.form.resetFields();
          this.$message.success(res.data.msg);
          this.$emit("onOk", false);
        } catch (error) {
          this.$emit("update:visible", false);
          console.log(error);
        }
      });
    },
    taskStatusChange(v) {
      if (v == 0 || v == 4) {
        const endTime = this.form.getFieldValue("end_time");
        if (!endTime) {
          this.form.setFieldsValue({
            end_time: moment().format("YYYY-MM-DD HH:mm:ss")
          });
        }
      } else {
        this.form.setFieldsValue({
          end_time: null
        });
      }
    },
    handleArchive() {
      const endTime = this.form.getFieldValue("end_time");
      if (!endTime) {
        this.$message.warning("请选择巡查结束时间");
        return;
      }
      const taskStatus = this.form.getFieldValue("task_status");
      if (taskStatus == 1) {
        this.$message.warning("任务状态未更新");
        return;
      }
      this.$confirm({
        title: "确认归档?",
        okText: "确认",
        cancelText: "取消",
        onOk: async () => {
          this.handleOk();
          try {
            let res = await archivePushTask(this.record.id);
            this.$message.success("归档成功");
          } catch (error) {
            console.log(error);
          }
        },
        onCancel: () => {
          this.$message.warning("取消归档");
        }
      });
    },
    updateCurPollutant() {
      editFields.forEach(v => this.form.getFieldDecorator(v));
      const form_ = {};
      form_["id"] = this.record["id"];
      form_["name"] = this.record["name"];
      form_["board_id"] = this.record["board_id"];
      form_["start_time"] = this.moment(this.record["start_time"]);
      form_["end_time"] = this.record["end_time"]
        ? this.moment(this.record["end_time"])
        : null;
      form_["ops_user_id"] = this.record["ops_user_id"];
      form_["road_id"] = this.record["road_id"];
      form_["task_status"] = this.record["task_status"];
      form_["task_distance"] = isCheckNumber(this.record["task_distance"])
        ? this.record["task_distance"] / 1000
        : "";
      form_["task_distance_total"] = isCheckNumber(
        this.record["task_distance_total"]
      )
        ? this.record["task_distance_total"] / 1000
        : "";
      form_["remark"] = this.record["remark"];
      this.getFileFromRecord();
      this.$nextTick(() => {
        this.form.setFieldsValue(form_);
        this.originForm = _.cloneDeep(this.form.getFieldsValue());
      });
    }
  }
};
</script>

<style lang="less" scoped>
.drawer-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background: #fff;
  text-align: right;
  z-index: 1;
}
/deep/ .ant-upload-list-picture-card .ant-upload-list-item {
  padding: 0;
}
</style>
